/* OSYN — Carousel AVIS (moteur dédié, auto-portant).
 * Transform-based : on translate la piste en coordonnées PHYSIQUES (offsetLeft +
 * translate + clientX) → la mise en page RTL du navigateur est respectée
 * automatiquement, zéro cas spécial scrollLeft (contrairement au moteur global).
 *  - Drag pointeur unifié souris+tactile, 1:1, inertie + snap-to-card.
 *  - Carte active (plus proche du centre) → .is-active (scale/halo/sweep CSS).
 *  - Halo « follow » translaté sous la carte active. Dots morphants maison.
 *  - Clavier LOGIQUE (RTL : ArrowRight = précédent). Autoplay opt + 5 gardes.
 *  - reduced-motion / 1 carte → PAS de moteur : scroll natif géré en CSS.
 *  - Amorce de défilement mobile (OsynUI.amorce) par un pilote propre au moteur, sauf autoplay.
 * Idempotent (shopify:section:load), cleanup symétrique, setPointerCapture try/catch.
 */
(function () {
  'use strict';
  if (window.customElements && customElements.get('osyn-reviews')) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  class OsynReviews extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.track = this.querySelector('[data-osyn-rv-track]');
      this.viewport = this.querySelector('[data-osyn-rv-viewport]');
      this.cards = [].slice.call(this.querySelectorAll('[data-osyn-rv-card]'));

      // pas de moteur : 1 carte, pas de piste, ou reduced-motion → scroll natif (CSS)
      // mais on câble quand même les flèches sur le scroll natif (pas de bouton mort).
      if (!this.track || !this.viewport || this.cards.length < 2 || REDUCE.matches) {
        this._initNative();
        return;
      }

      this.classList.add('is-engine');
      this.dir = getComputedStyle(this).direction;
      this.halo = this.querySelector('[data-osyn-rv-halo]');
      this.prevBtn = this.querySelector('[data-osyn-rv-prev]');
      this.nextBtn = this.querySelector('[data-osyn-rv-next]');
      this.dotsBox = this.querySelector('[data-osyn-rv-dots]');

      this.index = 0; this.tx = 0; this.vx = 0; this._mode = 'idle';
      this._activeIdx = null; this._dragging = false; this._raf = 0;
      this._tick = this._tick.bind(this);

      this._buildDots();
      this._bind();
      this._measure();
      this._goto(this._startIndex(), false);

      this._onResize = this._scheduleMeasure.bind(this);
      window.addEventListener('resize', this._onResize);
      this._onLoad = this._scheduleMeasure.bind(this);
      window.addEventListener('load', this._onLoad);

      this.autoplay = this.dataset.autoplay === 'true';
      this.apDelay = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
      if (this.autoplay) this._initAutoplay();
      else if (this.hasAttribute('data-osyn-amorce') && window.OsynUI && window.OsynUI.amorce) {
        window.OsynUI.amorce(this.viewport, this._amorceDriver());
      }
    }

    disconnectedCallback() {
      if (this._raf) cancelAnimationFrame(this._raf);
      clearTimeout(this._rzT);
      clearInterval(this._apTimer);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('load', this._onLoad);
      if (this._apIO) this._apIO.disconnect();
    }

    /* ---- mode natif (reduced-motion / 1 avis) : flèches → scroll natif --- */
    _initNative() {
      if (this._nativeBound || !this.viewport || !this.cards.length) return;
      this._nativeBound = true;
      var vp = this.viewport, cards = this.cards;
      var prev = this.querySelector('[data-osyn-rv-prev]');
      var next = this.querySelector('[data-osyn-rv-next]');
      var dir = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      var step = function () { return ((cards[0] && cards[0].getBoundingClientRect().width) || 300) + 20; };
      if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step() * dir, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step() * dir, behavior: 'smooth' }); });
    }

    /* ---- mesure (centres via getBoundingClientRect → RTL-safe) ----------
       On lit la position ÉCRAN de chaque carte à tx=0 : c._cx0 = centre carte
       relatif au bord du viewport. Indépendant de l'origine RTL/LTR de la piste
       (offsetLeft suppose à tort piste-gauche = viewport-gauche, faux en RTL). */
    _measure() {
      this.vpCenter = this.viewport.clientWidth / 2;
      var prev = this.tx || 0;
      this.track.style.setProperty('--osyn-rv-tx', '0px');
      var vpLeft = this.viewport.getBoundingClientRect().left;
      this.cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        c._cx0 = (r.left - vpLeft) + r.width / 2;
        c._w0 = r.width;                           // réutilisé par _startIndex (pas de reflow)
      });
      var self = this;
      this.targets = this.cards.map(function (c) { return self.vpCenter - c._cx0; });
      this.txMax = Math.max.apply(null, this.targets);
      this.txMin = Math.min.apply(null, this.targets);
      this.track.style.setProperty('--osyn-rv-tx', prev.toFixed(2) + 'px');
    }
    _scheduleMeasure() {
      clearTimeout(this._rzT);
      this._rzT = setTimeout(function () {
        this._measure(); this._goto(this.index, false);
      }.bind(this), 150);
    }
    /* Index de départ : centrer la carte 0 laisse un demi-viewport vide côté
       lecture-début (|targets[0]| grand). Si ce vide dépasse une demi-carte,
       on démarre un cran plus loin : la carte 0 vient combler le côté et la
       carte active garde un peek des deux côtés. Sur téléphone |targets[0]|
       est petit (simple marge de centrage) → on reste à 0, le premier avis
       reste centré. Math.abs = valable en RTL (le signe s'inverse, pas la
       grandeur). Garde >= 3 cartes : sur 2 avis, avancer déplacerait le vide
       de l'autre côté. */
    _startIndex() {
      if (this.cards.length < 3) return 0;
      var w = this.cards[0]._w0;
      if (!w) return 0; /* géométrie non mesurable → comportement d'origine */
      return Math.abs(this.targets[0]) > w / 2 ? 1 : 0;
    }

    /* ---- navigation ----------------------------------------------------- */
    _goto(i, animate) {
      this.index = Math.max(0, Math.min(this.cards.length - 1, i));
      this._target = this.targets[this.index];
      this._updateDots(); this._updateArrows();
      if (animate === false) { this.tx = this._target; this._applyTx(); this._mode = 'idle'; }
      else { this._mode = 'animate'; this._run(); }
    }
    _snapNearest() {
      var best = 0, bd = Infinity, self = this;
      this.targets.forEach(function (t, i) { var d = Math.abs(t - self.tx); if (d < bd) { bd = d; best = i; } });
      this.index = best; this._target = this.targets[best]; this._mode = 'animate';
      this._updateDots(); this._updateArrows();
    }

    _run() { if (!this._raf) this._raf = requestAnimationFrame(this._tick); }
    _tick() {
      if (this._mode === 'inertia') {
        this.tx += this.vx; this.vx *= 0.92;
        this.tx = Math.max(this.txMin - 80, Math.min(this.txMax + 80, this.tx));
        if (Math.abs(this.vx) < 0.4) this._snapNearest();
      } else if (this._mode === 'animate') {
        this.tx += (this._target - this.tx) * 0.18;
        if (Math.abs(this._target - this.tx) < 0.5) { this.tx = this._target; this._mode = 'idle'; }
      }
      this._applyTx();
      this._raf = (this._mode === 'inertia' || this._mode === 'animate') ? requestAnimationFrame(this._tick) : 0;
    }

    _applyTx() {
      this.track.style.setProperty('--osyn-rv-tx', this.tx.toFixed(2) + 'px');
      this._updateActive();
    }
    _updateActive() {
      var best = 0, bd = Infinity, self = this;
      this.cards.forEach(function (c, i) {
        var center = c._cx0 + self.tx;                 // _cx0 = écran à tx=0 (RTL-safe)
        var d = Math.abs(center - self.vpCenter);
        if (d < bd) { bd = d; best = i; }
      });
      if (best !== this._activeIdx) {
        if (this._activeIdx != null && this.cards[this._activeIdx]) this.cards[this._activeIdx].classList.remove('is-active');
        this.cards[best].classList.add('is-active');
        this._activeIdx = best;
        this._moveHalo(best);
      }
    }
    _moveHalo(i) {
      if (!this.halo) return;
      var x = this.cards[i]._cx0 + this.tx - this.vpCenter;
      this.halo.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
      this.halo.classList.add('is-on');
    }

    /* ---- bind ----------------------------------------------------------- */
    _bind() {
      var self = this;
      this.viewport.addEventListener('pointerdown', this._onDown.bind(this));
      this.viewport.addEventListener('pointermove', this._onMove.bind(this));
      this.viewport.addEventListener('pointerup', this._onUp.bind(this));
      this.viewport.addEventListener('pointercancel', this._onUp.bind(this));
      this.viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // clic post-drag → ne pas suivre le lien
      this.track.addEventListener('click', function (e) { if (self._moved) { e.preventDefault(); e.stopPropagation(); } }, true);

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self._goto(self.index - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self._goto(self.index + 1); });

      this.viewport.tabIndex = 0;
      this.viewport.setAttribute('role', 'group');
      this.viewport.addEventListener('keydown', this._onKey.bind(this));
    }
    _onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      this._dragging = true; this._moved = false;
      this._touch = e.pointerType === 'touch';      // tactile → swipe paginé (cranté)
      this._startX = e.clientX; this._startTx = this.tx; this._lastX = e.clientX; this.vx = 0;
      if (this._touch) {
        this._swipeStart = this.index;
        var a = this.targets[this.index];
        var n = this.targets[this.index + 1], p = this.targets[this.index - 1];
        var s1 = (n != null) ? Math.abs(n - a) : Infinity;
        var s2 = (p != null) ? Math.abs(p - a) : Infinity;
        this._stride = Math.min(s1, s2);
        if (!isFinite(this._stride)) this._stride = this.viewport.clientWidth;
      }
      this._mode = 'drag';
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = 0; }
      try { this.viewport.setPointerCapture(e.pointerId); } catch (err) {}
      this.classList.add('is-grabbing');
    }
    _onMove(e) {
      if (!this._dragging) return;
      var dx = e.clientX - this._startX;
      if (Math.abs(dx) > 4) this._moved = true;
      if (this._touch) {
        // 1 swipe = 1 carte MAX : on borne le drag à ±1 carte → sensation crantée (pas de rubber-band multi-cartes)
        var lo = Math.max(this.txMin, this._startTx - this._stride);
        var hi = Math.min(this.txMax, this._startTx + this._stride);
        this.tx = Math.max(lo, Math.min(hi, this._startTx + dx));
      } else {
        this.tx = Math.max(this.txMin - 80, Math.min(this.txMax + 80, this._startTx + dx));
      }
      this.vx = e.clientX - this._lastX; this._lastX = e.clientX;
      this._applyTx();
    }
    _onUp() {
      if (!this._dragging) return;
      this._dragging = false;
      this.classList.remove('is-grabbing');
      if (this._touch) { this._snapNearest(); this._run(); }   // cranté : atterrit sur start ou start±1, animé comme les flèches
      else { this._mode = 'inertia'; this._run(); }
    }
    _onKey(e) {
      var rtl = this.dir === 'rtl';
      if (e.key === 'ArrowRight') { e.preventDefault(); this._goto(this.index + (rtl ? -1 : 1)); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); this._goto(this.index + (rtl ? 1 : -1)); }
      else if (e.key === 'Home') { e.preventDefault(); this._goto(0); }
      else if (e.key === 'End') { e.preventDefault(); this._goto(this.cards.length - 1); }
    }

    /* ---- dots / flèches ------------------------------------------------- */
    _buildDots() {
      if (!this.dotsBox) return;
      var self = this, label = this.dataset.dotLabel || 'Avis';
      this.dots = this.cards.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'osyn-pdot';
        b.setAttribute('aria-label', label + ' ' + (i + 1));
        b.addEventListener('click', function () { self._goto(i); });
        self.dotsBox.appendChild(b); return b;
      });
    }
    _updateDots() {
      if (!this.dots) return;
      var idx = this.index;
      this.dots.forEach(function (d, i) {
        var on = i === idx; d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    _updateArrows() {
      if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= this.cards.length - 1;
    }

    /* ---- pilote d'amorce (contrat OsynUI.amorce, osyn-ui.js) -------------
       La piste est translatée, pas défilée : un décalage de défilement +off (vers la suite de
       la lecture, négatif en RTL) vaut tx − off. 40 % d'un pas : la carte active et les points
       ne bougent pas (l'index n'est pas recalculé pendant le mouvement). */
    _amorceDriver() {
      var self = this, rest = 0;
      return {
        rtl: this.dir === 'rtl',
        position: function () { return self.tx; },
        measure: function () {
          var next = self.targets[self.index + 1];
          return {
            pitch: next != null ? Math.abs(next - self.targets[self.index]) : 0,
            room: self.dir === 'rtl' ? self.txMax - self.tx : self.tx - self.txMin
          };
        },
        begin: function () {
          if (self._raf) { cancelAnimationFrame(self._raf); self._raf = 0; }
          self._mode = 'idle'; rest = self.tx;
        },
        frame: function (off) { self.tx = rest - off; self._applyTx(); },
        end: function () { self.tx = rest; self._applyTx(); },
        release: function () {},
        settle: function () { if (!self._dragging) { self._snapNearest(); self._run(); } }
      };
    }

    /* ---- autoplay (5 gardes : hover/focus/drag/hors-écran/onglet) ------- */
    _initAutoplay() {
      var self = this;
      this._hover = false; this._focusIn = false; this._visible = true;
      this.addEventListener('pointerenter', function () { self._hover = true; });
      this.addEventListener('pointerleave', function () { self._hover = false; });
      this.addEventListener('focusin', function () { self._focusIn = true; });
      this.addEventListener('focusout', function () { self._focusIn = false; });
      this._apIO = new IntersectionObserver(function (ents) { self._visible = ents[0].isIntersecting; }, { threshold: 0.3 });
      this._apIO.observe(this);
      this._apTimer = setInterval(function () {
        if (self._hover || self._focusIn || self._dragging || !self._visible || document.hidden) return;
        // wrap vers _startIndex (pas 0) : ne pas ré-exposer le vide de tête à chaque cycle
        self._goto(self.index >= self.cards.length - 1 ? self._startIndex() : self.index + 1);
      }, this.apDelay);
    }
  }

  if (window.customElements) customElements.define('osyn-reviews', OsynReviews);
})();
